import React from 'react'

import background from './../../../UI/icons/Galerias/background.svg'

import close from './../../../UI/icons/Galerias/Close.svg'
import next from './../../../UI/icons/Galerias/next.svg'
import prev from './../../../UI/icons/Galerias/prev.svg'

interface Props{
    generalGalleryOpened: boolean,
    galleryInfo: any,
    textures: any,
    handleGeneralGallery: any
}

interface State{
    ImageArray: any,
    fullGallery: boolean,
    currentImage: any,
    currentImageIndex: number
}

class GeneralGallery extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            ImageArray: [],
            fullGallery: false,
            currentImage: [],
            currentImageIndex: -1
        }
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.galleryInfo.Galeria !== this.props.galleryInfo.Galeria){
            this.handleGetGaleria()
        }
    }

    handleGetGaleria = () => {
        if(this.props.galleryInfo.Galeria){
            let arrayMixed: any = []
            if(this.props.galleryInfo.Niveles){
                this.props.galleryInfo.Galeria.forEach((r: any) => {
                    arrayMixed.push({path: 'Galeria', img: r.Imagen, nombre: r.Titulo});
                });

                this.props.galleryInfo.Planos.forEach((p: any) => {
                    arrayMixed.push({path: 'Planos',img: p.Imagen, nombre: p.Titulo});
                });
                
            }
            else{
                this.props.galleryInfo.Galeria.forEach((r: any) => {
                    arrayMixed.push({path: 'Amenidades', img: r.Imagen, nombre: r.Titulo}); 
                });
                
            }

            this.setState({ImageArray: arrayMixed})
        }
    }

    handleGetThumbs = () => {
        return(
            <div className='thumbs-gallery'>
                {
                    this.state.ImageArray.map((thumbs: any, index: number) => 
                    <div className='gallery-thumb-container' key={index}>
                        <img className='gallery-thumb' alt="" src={ this.props.textures[`${thumbs.img}`]} onClick={() => {this.handleOpenGallery(index)}} />
                        <div>{thumbs.nombre}</div>
                    </div>
                    )
                }
            </div>
        )
    }

    handleOpenGallery = (index: number) => {
        this.setState({
            fullGallery: !this.state.fullGallery,
            currentImageIndex: index
        })
    }

    handleNextImage = () => {
        this.state.currentImageIndex + 1 > this.state.ImageArray.length - 1 ? this.setState({currentImageIndex: 0}):this.setState({currentImageIndex: this.state.currentImageIndex + 1})
    }

    handlePrevImage = () => {
        this.state.currentImageIndex - 1 < 0 ? this.setState({currentImageIndex: this.state.ImageArray.length - 1}):this.setState({currentImageIndex: this.state.currentImageIndex - 1})
    }

    render(){
        return (
            <React.Fragment>
                <div className={this.props.generalGalleryOpened ? "general-gallery fade-in":"general-gallery fade-out"}> 
                    <img className="galerias-background" src={background} alt=""/>
                    <div className="close-gallery" onClick={() => {this.props.handleGeneralGallery()}}>
                        <img src={close} alt=""></img>
                    </div>
                    {
                        this.state.ImageArray.length > 0 ? this.handleGetThumbs():null
                    }
                </div>
                <div className={this.state.fullGallery ? "full-gallery fade-in":"full-gallery fade-out"}>
                    <img className="galerias-background" src={background} alt=""/>
                    <img 
                        src={this.state.ImageArray.length > 0 && this.state.currentImageIndex !== -1 ? this.props.textures[`${this.state.ImageArray[this.state.currentImageIndex].img}`]: ""}
                        className='gallery-image'
                        alt=""
                    ></img>
                    <div className="close-gallery" onClick={() => {this.handleOpenGallery(-1)}}>
                        <img src={close} alt=""></img>
                    </div>
                    {
                        this.state.ImageArray.length > 1 ?
                        <React.Fragment>
                            <div className="next-gallery" onClick={() => {this.handleNextImage()}}>
                                <img src={next} alt=""></img>
                            </div>
                            <div className="previous-gallery" onClick={() => {this.handlePrevImage()}}>
                                <img src={prev} alt=""></img>
                            </div>
                        </React.Fragment>: null
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default GeneralGallery